'use client'

import { useState, useContext } from 'react'
import { Button } from '@/components/ui/shadcn/button'
import { AuthContext } from '@/contexts/AuthContext'
import { fetcher } from '@/lib/api/fetch'
import Empty from '@/components/common/feedback/Empty'
import OrganizationModal from '@/components/common/modals/OrganizationModal'

export default function NoOrganization() {
  const authContext = useContext(AuthContext)
  const [checking, setChecking] = useState(false)
  const [error, setError] = useState(null)
  const [createOpen, setCreateOpen] = useState(false)
  const [modalPage, setModalPage] = useState('create')

  const isAdmin = authContext.user?.isAdmin

  const handleRefresh = async () => {
    setChecking(true)
    setError(null)

    try {
      const res = await fetcher(
        '/api/admin/user/check-organizations',
        { method: 'GET' },
        authContext,
      )

      if (!res.ok) {
        setError('Failed to check for organizations. Please try again.')
        setChecking(false)
        return
      }

      const data = await res.json()

      if (data.found && data.organization) {
        authContext.setuser(
          {
            ...authContext.user,
            organization: data.organization,
          },
          () => {
            window.location.replace('/manager/dashboard')
          },
        )
      } else {
        setError('No organization invitations found yet.')
        setChecking(false)
      }
    } catch {
      setError('Failed to check for organizations. Please try again.')
      setChecking(false)
    }
  }

  const handleLogout = () => {
    authContext.signout(() => {
      window.location.replace('/')
    })
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-6">
      <Empty
        title={isAdmin ? 'Welcome to Tectra' : 'No Organization Access'}
        description={
          isAdmin
            ? 'No organizations exist yet. Create the first one to finish setting up this installation.'
            : "You don't have access to any organizations yet. Please contact your administrator to request an invitation."
        }
        alert={error}
        actions={
          <div className="mt-2 flex w-full max-w-sm flex-col gap-2">
            {isAdmin && (
              <Button
                onClick={() => {
                  setModalPage('create')
                  setCreateOpen(true)
                }}
                className="w-full bg-emerald-600 text-white hover:bg-emerald-700"
              >
                Create First Organization
              </Button>
            )}
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
              <Button
                onClick={handleRefresh}
                disabled={checking}
                className="w-full"
              >
                {checking ? 'Checking...' : 'Check Again'}
              </Button>
              <Button
                variant="outline"
                onClick={handleLogout}
                disabled={checking}
                className="w-full border-red-200 text-red-700 hover:bg-red-50"
              >
                Log Out
              </Button>
            </div>
          </div>
        }
      />
      {isAdmin && (
        <OrganizationModal
          open={createOpen}
          setOpen={setCreateOpen}
          page={modalPage}
          setPage={setModalPage}
          startPage="create"
        />
      )}
    </div>
  )
}
